@if (content) {
  <div class="container-explainer" [ngStyle]="{ top: explainer.top + 25 + 'px', left: explainer.left - 142 + 'px' }">
    <p class="arrow" [ngClass]="calcPositionArrow"></p>
    <div class="content-explainer">
      @if (content.header) {
        <h2 class="content-explainer-header item-content">{{ "explainer." + content.header | translate }}</h2>
      }
      @if (content.headerKey) {
        <h2 class="content-explainer-header item-content">{{ content.headerKey | translate }}</h2>
      }
      @if (content.description) {
        <p class="content-explainer-description item-content" [innerHTML]="'explainer.' + content.description | translate"></p>
      }
      @if (content.descriptionKey) {
        <p class="content-explainer-description item-content" [innerHTML]="content.descriptionKey | translate"></p>
      }
      @if (content.link) {
        <span class="content-explainer-line"></span>
      }
      @if (content.link) {
        <p class="content-explainer-link item-content">{{ "explainer." + content.link | translate }}</p>
      }
    </div>
  </div>
}
@if (content) {
  <div class="container-explainer-overlay" (click)="closeExplainer()"></div>
}
